import { ProviderBuilder, EGenMode } from '@educraft/base';
import { Spojovacka } from './generators/Spojovacka';
import { Dvirka } from './generators/Dvirka';
import { CardsAside } from './generators/CardsAside';
import { GuessWho } from './generators/GuessWho';
import { Behacka } from './generators/Behacka';
import { HraOkolo } from './generators/HraOkolo';

import { Voltik } from './generators/Voltik';
import { Vaha } from './generators/Vaha';
import { HraDopredu } from './generators/HraDopredu';
import { Trychtyr } from './generators/Trychtyr';
import { Losovani } from './generators/Losovani';
import { MiniLUK__Base } from './generators/MiniLUK';
import { Mobilka__Base, Mobilka__Mini } from './generators/Mobilka';
import {
  Piccolo__Base,
  Piccolo__Mini,
  Piccolo__2Cols,
  Piccolo__ZigZag1,
  Piccolo__ZigZag2,
  Piccolo__Diagonal,
  Piccolo__Okolo,
  Piccolo__23,
  Piccolo__343,
  Piccolo__Pyramid,
  Piccolo__P0,
  Piccolo__P1,
  Primo__Base,
  Primo__Mini,
  Primo__2Cols,
  Primo__ZigZag1,
  Primo__ZigZag2,
  Primo__Diagonal,
  Primo__P0,
  Primo__P1,
  Maximo__Base,
  Maximo__Mini,
  Maximo__2Cols,
  Maximo__ZigZag1,
  Maximo__ZigZag2,
  Maximo__Diagonal,
} from './generators/Logico';
import { Karty__Zaklad, Karty__Cerny, Karty__Duha } from './generators/Karty';
import { Domino } from './generators/Domino';
import { Kolecko } from './generators/Kolecko';
import { Bingo__2x3, Bingo__3x4, Bingo__4x4, Bingo__4x5 } from './generators/BingoBase';
import { Pexeso } from './generators/Pexeso';
import { Policka } from './generators/Policka';
import { Pyramida } from './generators/Pyramida';
import { Los__Zaklad, Los__VedleSebe } from './generators/Los';
import { Tabulka } from './generators/Tabulka';
import { Flipbook } from './generators/Flipbook';
import { KdoMa__Okolo, KdoMa__Start } from './generators/KdoMa';
import { Rybicky } from './generators/Rybicky';
import { Lepitko } from './generators/Lepitko';
import { Kostky } from './generators/Kostky';
import { Zasunovacka } from './generators/Zasunovacka';
import { Sipky } from './generators/Sipky';
import { Kolicky__1 } from './generators/Kolicky__1';
import { Kolicky__2 } from './generators/Kolicky__2';
import { Prekvapik__1 } from './generators/Prekvapik__1';
import { Prekvapik__2 } from './generators/Prekvapik__2';
import { Prekvapik__3 } from './generators/Prekvapik__3';
import { Tabulka100 } from './generators/Tabulka100';
import { Panak } from './generators/Panak';
import { PocitaniKusu } from './generators/PocitaniKusu';
import { Poloviny } from './generators/Poloviny';
import { Hex } from './generators/Hex';
import { Grafomotorika } from './generators/Grafomotorika';
import { Octagon } from './generators/Octagon';
import { Duha } from './generators/Duha';
import { Fotografie } from './generators/Fotografie';
import { Pastelky } from './generators/Pastelky';
import { Dum } from './generators/Dum';
import { Cesta } from './generators/Cesta';
import { Cesticka__Base, Cesticka__Quiz } from './generators/Cesticka';
import { Vojtik } from './generators/Vojtik';
import { Seznam } from './generators/Seznam';
import { PocitaniTabulka } from './generators/PocitaniTabulka';
import {
  LCD_Tabulka__3,
  LCD_Tabulka__5,
  LCD_Tabulka__8,
  LCD_Tabulka__10,
} from './generators/LCD_Tabulka';
import { Navigace } from './generators/Navigace';
import { Obchod } from './generators/Obchod';
import { Provazek__3, Provazek__4, Provazek__5, Provazek__6 } from './generators/Provazek';
import { Rada } from './generators/Rada';
import { Trimino } from './generators/Trimino';
import {
  KalendarMesic__Base,
  KalendarMesic__TentoRok,
  KalendarMesic__DalsiRok,
} from './generators/KalendarMesic__Base';

export function registerLayoutLabel(builder: ProviderBuilder) {
  builder.add(EGenMode.LayoutLabel, Spojovacka, 'Label.Spojovacka');
  builder.add(EGenMode.LayoutLabel, Dvirka, 'Label.Dvirka');
  builder.add(EGenMode.LayoutLabel, CardsAside, 'Label.CardsAside');
  builder.add(EGenMode.LayoutLabel, GuessWho, 'Label.GuessWho');
  builder.add(EGenMode.LayoutLabel, Behacka, 'Label.Behacka');
  builder.add(EGenMode.LayoutLabel, HraOkolo, 'Label.HraOkolo');
  builder.add(EGenMode.LayoutLabel, Voltik, 'Label.Voltik');
  builder.add(EGenMode.LayoutLabel, Vaha, 'Label.Vaha');
  builder.add(EGenMode.LayoutLabel, HraDopredu, 'Label.HraDopredu');
  builder.add(EGenMode.LayoutLabel, Trychtyr, 'Label.Trychtyr');
  builder.add(EGenMode.LayoutLabel, Losovani, 'Label.Losovani');
  builder.add(EGenMode.LayoutLabel, MiniLUK__Base, 'Label.MiniLUK__Base');
  builder.add(EGenMode.LayoutLabel, Mobilka__Base, 'Label.Mobilka__Base');
  builder.add(EGenMode.LayoutLabel, Mobilka__Mini, 'Label.Mobilka__Mini');
  builder.add(EGenMode.LayoutLabel, Piccolo__Base, 'Label.Piccolo__Base');
  builder.add(EGenMode.LayoutLabel, Piccolo__Mini, 'Label.Piccolo__Mini');
  builder.add(EGenMode.LayoutLabel, Piccolo__2Cols, 'Label.Piccolo__2Cols');
  builder.add(EGenMode.LayoutLabel, Piccolo__ZigZag1, 'Label.Piccolo__ZikZak1');
  builder.add(EGenMode.LayoutLabel, Piccolo__ZigZag2, 'Label.Piccolo__ZikZak2');
  builder.add(EGenMode.LayoutLabel, Piccolo__Diagonal, 'Label.Piccolo__Diagonal');
  builder.add(EGenMode.LayoutLabel, Piccolo__Okolo, 'Label.Piccolo__Okolo');
  builder.add(EGenMode.LayoutLabel, Piccolo__23, 'Label.Piccolo__23');
  builder.add(EGenMode.LayoutLabel, Piccolo__343, 'Label.Piccolo__343');
  builder.add(EGenMode.LayoutLabel, Piccolo__Pyramid, 'Label.Piccolo__Pyramid');
  builder.add(EGenMode.LayoutLabel, Piccolo__P0, 'Label.Piccolo__P0');
  builder.add(EGenMode.LayoutLabel, Piccolo__P1, 'Label.Piccolo__P1');
  builder.add(EGenMode.LayoutLabel, Primo__Base, 'Label.Primo__Base');
  builder.add(EGenMode.LayoutLabel, Primo__Mini, 'Label.Primo__Mini');
  builder.add(EGenMode.LayoutLabel, Primo__2Cols, 'Label.Primo__2Cols');
  builder.add(EGenMode.LayoutLabel, Primo__ZigZag1, 'Label.Primo__ZigZag1');
  builder.add(EGenMode.LayoutLabel, Primo__ZigZag2, 'Label.Primo__ZigZag2');
  builder.add(EGenMode.LayoutLabel, Primo__Diagonal, 'Label.Primo__Diagonal');
  builder.add(EGenMode.LayoutLabel, Primo__P0, 'Label.Primo__P0');
  builder.add(EGenMode.LayoutLabel, Primo__P1, 'Label.Primo__P1');
  builder.add(EGenMode.LayoutLabel, Maximo__Base, 'Label.Maximo__Base');
  builder.add(EGenMode.LayoutLabel, Maximo__Mini, 'Label.Maximo__Mini');
  builder.add(EGenMode.LayoutLabel, Maximo__2Cols, 'Label.Maximo__2Cols');
  builder.add(EGenMode.LayoutLabel, Maximo__ZigZag1, 'Label.Maximo__ZigZag1');
  builder.add(EGenMode.LayoutLabel, Maximo__ZigZag2, 'Label.Maximo__ZigZag2');
  builder.add(EGenMode.LayoutLabel, Maximo__Diagonal, 'Label.Maximo__Diagonal');
  builder.add(EGenMode.LayoutLabel, Karty__Zaklad, 'Label.Karty__Zaklad');
  builder.add(EGenMode.LayoutLabel, Karty__Cerny, 'Label.Karty__Cerny');
  builder.add(EGenMode.LayoutLabel, Karty__Duha, 'Label.Karty__Duha');
  builder.add(EGenMode.LayoutLabel, Domino, 'Label.Domino');
  builder.add(EGenMode.LayoutLabel, Kolecko, 'Label.Kolecko');
  builder.add(EGenMode.LayoutLabel, Bingo__2x3, 'Label.Bingo__2x3');
  builder.add(EGenMode.LayoutLabel, Bingo__3x4, 'Label.Bingo__3x4');
  builder.add(EGenMode.LayoutLabel, Bingo__4x4, 'Label.Bingo__4x4');
  builder.add(EGenMode.LayoutLabel, Bingo__4x5, 'Label.Bingo__4x5');
  builder.add(EGenMode.LayoutLabel, Pexeso, 'Label.Pexeso');
  builder.add(EGenMode.LayoutLabel, Policka, 'Label.Policka');
  builder.add(EGenMode.LayoutLabel, Pyramida, 'Label.Pyramida');
  builder.add(EGenMode.LayoutLabel, Los__Zaklad, 'Label.Los__Zaklad');
  builder.add(EGenMode.LayoutLabel, Los__VedleSebe, 'Label.Los__VedleSebe');
  builder.add(EGenMode.LayoutLabel, Tabulka, 'Label.Tabulka');
  builder.add(EGenMode.LayoutLabel, Flipbook, 'Label.Flipbook');
  builder.add(EGenMode.LayoutLabel, KdoMa__Okolo, 'Label.KdoMa__Okolo');
  builder.add(EGenMode.LayoutLabel, KdoMa__Start, 'Label.KdoMa__Start');
  builder.add(EGenMode.LayoutLabel, Rybicky, 'Label.Rybicky');
  builder.add(EGenMode.LayoutLabel, Lepitko, 'Label.Lepitko');
  builder.add(EGenMode.LayoutLabel, Kostky, 'Label.Kostky');
  builder.add(EGenMode.LayoutLabel, Zasunovacka, 'Label.Zasunovacka');
  builder.add(EGenMode.LayoutLabel, Sipky, 'Label.Sipky');
  builder.add(EGenMode.LayoutLabel, Kolicky__1, 'Label.Kolicky__1');
  builder.add(EGenMode.LayoutLabel, Kolicky__2, 'Label.Kolicky__2');
  builder.add(EGenMode.LayoutLabel, Prekvapik__1, 'Label.Prekvapik__1');
  builder.add(EGenMode.LayoutLabel, Prekvapik__2, 'Label.Prekvapik__2');
  builder.add(EGenMode.LayoutLabel, Prekvapik__3, 'Label.Prekvapik__3');
  builder.add(EGenMode.LayoutLabel, Tabulka100, 'Label.Tabulka100');
  builder.add(EGenMode.LayoutLabel, Panak, 'Label.Panak');
  builder.add(EGenMode.LayoutLabel, PocitaniKusu, 'Label.PocitaniKusu');
  builder.add(EGenMode.LayoutLabel, Poloviny, 'Label.Poloviny');
  builder.add(EGenMode.LayoutLabel, Hex, 'Label.Hex');
  builder.add(EGenMode.LayoutLabel, Grafomotorika, 'Label.Grafomotorika');
  builder.add(EGenMode.LayoutLabel, Octagon, 'Label.Octagon');
  builder.add(EGenMode.LayoutLabel, Duha, 'Label.Duha');
  builder.add(EGenMode.LayoutLabel, Fotografie, 'Label.Fotografie');
  builder.add(EGenMode.LayoutLabel, Pastelky, 'Label.Pastelky');
  builder.add(EGenMode.LayoutLabel, Dum, 'Label.Dum');
  builder.add(EGenMode.LayoutLabel, Cesta, 'Label.Cesta');
  builder.add(EGenMode.LayoutLabel, Cesticka__Base, 'Label.Cesticka__Base');
  builder.add(EGenMode.LayoutLabel, Cesticka__Quiz, 'Label.Cesticka__Quiz');
  builder.add(EGenMode.LayoutLabel, Vojtik, 'Label.Vojtik');
  builder.add(EGenMode.LayoutLabel, Seznam, 'Label.Seznam');
  builder.add(EGenMode.LayoutLabel, PocitaniTabulka, 'Label.PocitaniTabulka');
  builder.add(EGenMode.LayoutLabel, LCD_Tabulka__3, 'Label.LCD_Tabulka__3');
  builder.add(EGenMode.LayoutLabel, LCD_Tabulka__5, 'Label.LCD_Tabulka__5');
  builder.add(EGenMode.LayoutLabel, LCD_Tabulka__8, 'Label.LCD_Tabulka__8');
  builder.add(EGenMode.LayoutLabel, LCD_Tabulka__10, 'Label.LCD_Tabulka__10');
  builder.add(EGenMode.LayoutLabel, Navigace, 'Label.Navigace');
  builder.add(EGenMode.LayoutLabel, Obchod, 'Label.Obchod');
  builder.add(EGenMode.LayoutLabel, Provazek__3, 'Label.Provazek__3');
  builder.add(EGenMode.LayoutLabel, Provazek__4, 'Label.Provazek__4');
  builder.add(EGenMode.LayoutLabel, Provazek__5, 'Label.Provazek__5');
  builder.add(EGenMode.LayoutLabel, Provazek__6, 'Label.Provazek__6');
  builder.add(EGenMode.LayoutLabel, Rada, 'Label.Rada');
  builder.add(EGenMode.LayoutLabel, Trimino, 'Label.Trimino');
  builder.add(EGenMode.LayoutLabel, KalendarMesic__TentoRok, 'Label.KalendarMesic__TentoRok');
  builder.add(EGenMode.LayoutLabel, KalendarMesic__DalsiRok, 'Label.KalendarMesic__DalsiRok');
}
